import { PDFDocument } from 'pdf-lib';
import { addDocumentSign, updateTemplate } from '../../../../Services/APIConfig';
import { useDispatch, useSelector } from 'react-redux';
import { selecteFileStatus, setPreviewDataAction } from '../../../../Store/Redux/FileListSlice';
import { mapTables } from '../../../../utils/MapTables';
import { getDropdownFields, getInputFields } from '../../../../utils/CkMapInputFields';
import { updateContent } from '../../../../Store/Redux/CKEditorSlice';
import GenerateThumbnail from '../../../../utils/GenerateThumbnail';
import { pageSizes } from '../../../../utils/PageSizes';
import CustomToast from '../../../Common/CustomToast';

export const mapTemplateData = async (
  base64,
  templatePayload,
  getSignCoordinates,
  tempDiv,
  htmlData,
  setIsLoading,
  navigate,
  dispatch,
  enableOtp,
  documentID,
  storedRecipients,
  enableDownload,
  getPicture,
  getLocation,
  stampBase64,
  arrayOne,
  stampConfig,
  additionalCharges,
  isAdditionalAmountRequired
) => {
  const loadPdf = await PDFDocument.load(base64);
  const pdfPages = loadPdf.getPages();

  //if template doesnt has any signatures
  const mapRecipients = mapDefaultFields(storedRecipients, pdfPages, false);
  console.log(templatePayload.selectedRecipients);

  arrayOne?.templateInfoConfig.map(tc => {
    let sn = templatePayload.selectedRecipients.find(r => r.name == tc.id);
    if (sn) {
      tc.uuid = sn.uuid;
    }
  });

  let templatePayloadObj = {
    documentPdf: base64,
    // enableOtp,
    enableDownload: enableDownload,
    getPicture,
    getLocation,
    recipientData: [],
    templateInfoConfig: arrayOne?.templateInfoConfig,
    stampConfig: stampConfig.stampConfig,
    ...isAdditionalAmountRequired,
    ...additionalCharges
  };

  const updatedTemplatePayload = {
    ...templatePayloadObj,
    docId: documentID,
    isTemplate: true
  };
  await templateRecipientCoord(getSignCoordinates, tempDiv, stampBase64, mapRecipients, updatedTemplatePayload);

  if (stampBase64.length > 0 && [...getSignCoordinates]?.length > 0) {
    const mapStampDeafultcoord = mapDefaultFields(storedRecipients, stampBase64, false);
    storedRecipients.map(item => {
      const findRecp = updatedTemplatePayload.recipientData.find(elem => elem.recipientId === item.uuid);
      const findDefaultCoord = mapStampDeafultcoord.find(ele => ele.recipientId === item.uuid);

      if (findRecp) {
        findRecp.coordinates = [...findRecp.coordinates, ...findDefaultCoord.coordinates];
      } else {
        updatedTemplatePayload.recipientData.push(findDefaultCoord);
      }
    });
  } else {
    const mapStampDeafultcoord = mapDefaultFields(storedRecipients, null, false);
    storedRecipients.map(item => {
      const findRecp = updatedTemplatePayload.recipientData.find(elem => elem.recipientId === item.uuid);
      const findDefaultCoord = mapStampDeafultcoord.find(ele => ele.recipientId === item.uuid);

      if (findRecp) {
        findRecp.coordinates = [...findRecp.coordinates, ...findDefaultCoord.coordinates];
      } else {
        updatedTemplatePayload.recipientData.push(findDefaultCoord);
      }
    });
  }

  try {
    console.log({ okok: '1' });
    const resp = await addDocumentSign(documentID, updatedTemplatePayload);
    dispatch(setPreviewDataAction(htmlData));
    setTimeout(() => {
      if (setIsLoading) {
        setIsLoading(false);
      }

      navigate(`/templatepreview?esign=${true}&pdf=${false}`);
    }, 300);
  } catch (error) {
    if (setIsLoading) {
      setIsLoading(false);
    }
    // console.log(error);
  }
};

const templateRecipientCoord = async (
  getSignCoordinates,
  tempDiv,
  stampBase64,
  mapRecipients,
  updatedTemplatePayload
) => {
  if (getSignCoordinates.length > 0) {
    [...getSignCoordinates].forEach(el => {
      if (el.getAttribute('data-recp')) {
        const checkRecp = updatedTemplatePayload.recipientData.find(
          item => item.recipientId === el.getAttribute('data-recp')
        );

        if (!checkRecp) {
          // for getting all the coordinates for a particular recipient
          const coordArr = getIndividualCoordinates(el, getSignCoordinates, stampBase64, tempDiv);

          updatedTemplatePayload.recipientData.push({
            recipientId: el.getAttribute('data-recp'),
            coordinates: coordArr.filter(Boolean)
          });
        }
      }
    });
  } else {
    updatedTemplatePayload.recipientData = mapRecipients;
  }
};

const getIndividualCoordinates = (el, getSignCoordinates, stampBase64, tempDiv) => {
  return [...getSignCoordinates].map(element => {
    if (element.getAttribute('data-recp') === el.getAttribute('data-recp')) {
      const elid = element.getAttribute('id');

      const findEl = tempDiv.querySelector('#' + elid);

      const pageOffset = stampBase64?.length > 0 ? findEl.offsetTop - 165 * stampBase64?.length : findEl.offsetTop;

      const defaultpageNumber = Math.floor(pageOffset / 841) + 1;

      const pageNumber = defaultpageNumber;

      let newPagenumber = pageNumber === 0 ? 1 : pageNumber;

      const offsetTop = stampBase64?.length > 0 ? pageOffset - pageNumber * 8 : pageOffset;

      const offsetLeft = findEl.offsetLeft + 1;

      const pageheight = 841;

      //setting x positon
      const updateX = offsetLeft < 200 ? 595 - offsetLeft - 150 : 595 - offsetLeft - 155;
      const checkXpos = offsetLeft < 200 ? updateX + 5 : updateX + 10;
      const chx = checkXpos <= 0 ? 1 : checkXpos;

      //setting y positon
      const newY = pageheight * newPagenumber - offsetTop;
      const changeY = newY - 40;
      const checkPostion = changeY > 700 ? changeY - 12 : changeY;
      const negY = checkPostion <= 0 ? 2 : checkPostion;

      return {
        xCoOrdinates: chx,
        yCoOrdinates: negY,
        pageNo: newPagenumber || 1
      };
    } else {
      return false;
    }
  });
};

export const mapDefaultFields = (storedRecipients, pages, docId) => {
  return storedRecipients.map((item, index) => {
    const xcoord = index === 0 ? 1 : 4 + index * 160;
    const updatexcoord = index > 7 ? 4 + (index - 8) * 160 : 4 + (index - 4) * 160;
    const ycoord = index > 7 ? 140 : 70;

    const coordianteValues = {
      xCoOrdinates: xcoord > 440 ? updatexcoord : xcoord,
      yCoOrdinates: xcoord > 440 ? ycoord : 2,
      pageNo: 1
    };
    const getRecipientId = docId ? item.docIds?.find(docData => docData.docId === docId) : { uuid: item.uuid };

    return {
      recipientId: getRecipientId.uuid,
      enableOtp: item.enableOtp,
      coordinates: pages
        ? pages.map((page, pageIndex) => {
            return { ...coordianteValues, pageNo: pageIndex + 1 };
          })
        : [coordianteValues]
    };
  });
};

export const getRecipientCoord = (signData, pdfData, inputValues) => {
  return inputValues.map(val => {
    const newX = val.coord ? val.coord?.x + 1 : 1;
    const xperWidth = val.coord?.pageWidth ? val.coord?.pageWidth - newX - 150 : 600 - newX;
    const updatedX = xperWidth <= 0 ? 1 : xperWidth;

    const newY = val.coord?.newY;
    const updatedY = newY <= 0 ? 1 : newY;

    if (pdfData.id === val.pdfId && val.uuid === signData.uuid) {
      return {
        xCoOrdinates: updatedX,
        yCoOrdinates: updatedY,
        pageNo: val.coord?.pageNo
      };
    } else {
      return false;
    }
  });
};

const mapDataFields = (inputValues, pdfData, payloadArr) => {
  return inputValues?.length > 0
    ? inputValues.map(el => {
        if (pdfData.id === el.pdfId && pdfData.docId === el.pdfdocId) {
          const findEl = payloadArr.recipientData.find(element => element.recipientId === el.uuid);

          if (!findEl) {
            const findRecipients = getRecipientCoord(el, pdfData, inputValues);

            const filterCoord = findRecipients.filter(Boolean);

            return payloadArr.recipientData.push({
              recipientId: el.uuid,
              coordinates: filterCoord
            });
          }
        } else {
          return payloadArr.recipientData.push('');
        }
      })
    : [];
};

export const mapInputData = (
  payloadData,
  defaultPdfSign,
  selectedFile,
  storedRecipients,
  setIsLoading,
  inputValues
) => {
  if (defaultPdfSign.enabled) {
    selectedFile.forEach(async pdfData => {
      const loadPdfPages = await PDFDocument.load(pdfData.dataUrl);
      const pages = loadPdfPages.getPages();

      payloadData.documentPdf = pdfData.dataUrl;
      const updatedRecipientData = mapDefaultFields(storedRecipients, pages, pdfData.docId);
      payloadData.recipientData = updatedRecipientData;
      try {
        const updatedPayload = {
          ...payloadData,
          isTemplate: false
        };
        console.log({ okok: '3' });
        await addDocumentSign(pdfData.docId, updatedPayload);
      } catch (error) {
        if (setIsLoading) {
          setIsLoading(false);
        }
      }
    });
  } else {
    selectedFile?.forEach(async item => {
      payloadData.docId = item.docId;

      payloadData.recipientData = [];
      const updatedPayload = {
        ...payloadData,
        isTemplate: false
      };

      mapDataFields(inputValues, item, updatedPayload);

      const filterData = updatedPayload.recipientData?.filter(recpData => recpData !== '');
      const enableOtpMap = storedRecipients.reduce((map, recipient) => {
        map[recipient.uuid] = recipient.enableOtp;
        return map;
      }, {});

      const updatedFilterData = filterData.map(recipient => {
        return {
          ...recipient,
          enableOtp: enableOtpMap[recipient.recipientId]
        };
      });
      updatedPayload.recipientData = updatedFilterData;

      try {
        console.log({ okok: '2' });
        await addDocumentSign(item.docId, updatedPayload);
      } catch (error) {
        setIsLoading(false);
      }
    });
  }
};

const getWindowRelativeOffset = async (parent, element) => {
  const elementRect = element.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();
  const relativeX = elementRect.left - parentRect.left;
  const relativeY = elementRect.top - parentRect.top;
  return { x: relativeX, y: relativeY };
};

export const handleTemplateSave = async (
  editor,
  createmode,
  dispatch,
  fileId,
  holdTemplateName,
  borderData,
  marginData,
  editorPageSize,
  stampConfig,
  shouldexit,
  handleExit,
  pageOrientation,
  additionalCharges,
  isAdditionalAmountRequired,
  templateStatus
) => {
  const { showToast } = CustomToast();
  const checkData = editor.getData()?.trim();
  const container = createmode === 'true' && document.querySelector('#editor');

  if (checkData === '' && container?.textContent === '' && !additionalCharges) {
    showToast('error', 'Cannot save blank template');
    return false;
  }

  const findDoc = document.querySelectorAll('.template-input-selector');
  let fieldsList = [];
  if (findDoc.length) {
    const res = getInputFields(findDoc);
    fieldsList.inputFields = res;
  }

  const findSelectDropDown = document.querySelectorAll('.template-dropdown');
  const selectDetails = [];
  if (findSelectDropDown?.length) {
    getDropdownFields(findSelectDropDown, selectDetails);
  }
  fieldsList.selectFields = selectDetails;

  const newData =
    createmode === 'true'
      ? document.querySelector('#editor')?.innerHTML
      : document.querySelector('#preview-container')?.innerHTML;

  const tempDiv = document.createElement('div');

  let modHtml = newData.replace(/\./g, ' .');
  tempDiv.innerHTML = modHtml;

  mapTables(tempDiv);

  dispatch(updateContent(tempDiv.innerHTML));
  const thumbnailData = tempDiv.innerHTML;

  const thumbnail = await GenerateThumbnail(thumbnailData);
  let fields = fieldsList.inputFields?.length ? fieldsList.inputFields : [];
  if (document.getElementById('editor')) {
    document.getElementById('editor').scrollTo(0, 0);
    fields.map(async f => {
      if (f.isrecipient == 'esign') {
        if (document.getElementById(f.id)) {
          f.coord = await getWindowRelativeOffset(
            document.querySelector('.editor-wrapper'),
            document.getElementById(f.id)
          );
        }
      }
    });
  }

  if (!thumbnail) {
    console.error('Thumbnail generation failed.');
  } else {
    const data = {
      templateId: fileId,
      templateName: holdTemplateName,
      templateStatus: templateStatus,
      templateThumbnail: thumbnail,
      templateHtml: tempDiv.innerHTML,
      templatePdfPath: [],
      templateConfig: {
        fields: fields,
        dropdownField: fieldsList.selectFields?.length ? fieldsList.selectFields : [],
        borderData: JSON.stringify(borderData),
        marginData: JSON.stringify(marginData),
        editorPageSize: editorPageSize || pageSizes[0],
        stampConfig: stampConfig,
        pageOrientation: pageOrientation,
        ...isAdditionalAmountRequired,
        ...additionalCharges
      }
    };
    // stampConfig
    if (stampConfig && stampConfig?.isRecipientToPayStamp) {
      data.templateConfig.isAdditionalAmountRequired = true;
    }
    let response = await updateTemplate(fileId, data);
    if (response.status == 200) {
      if (shouldexit) {
        if (handleExit) {
          handleExit();
        }
      }
      return true;
    } else {
      if (response.message) {
        showToast('error', response.message);
      }
      return false;
    }
  }
};
